import { Avatar } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { DialogSelected } from "../../../constant/common";
import { GA_LABEL_ENUMS, triggerGAEvent } from "../../../constant/google-analytics/GAEvents";
import { StateContext } from "../../../context/globalContext/context";
import { iGlobalContext } from "../../../context/globalContext/interface";
import formatPhoneNumber from "../../../hooks/phoneFormater";
import styles from "./profile.module.scss";
import Typography from "../typography/Typography";
import AppButton from "../button/button";
import { chevron_right, logoutIcon, newEditIcon } from "../../../constant";
import { toastMessage } from "../../../helpers/toast/toastMessage";
import { Messages } from "../../../constant/messages/toastMessages";

interface iProps {
  onClick: () => void;
  onLogoutClick?: () => void;
}

function Profile({ onClick, onLogoutClick }: iProps): JSX.Element {
  const state = React.useContext(StateContext);
  const { userInfo, isMobile, loginCreateAccountState, setLoginCreateAccountState }: iGlobalContext = state;

  const handleEditAccount = () => {
    triggerGAEvent(GA_LABEL_ENUMS.home_edit_profile_click);
    setLoginCreateAccountState({
      flag: true,
      page: DialogSelected.EDIT_ACCOUNT,
    });
    if (isMobile) {
      onClick();
    }
  };

  const handleLogout = () => {
    triggerGAEvent(GA_LABEL_ENUMS.Logout);
    setLoginCreateAccountState({ ...loginCreateAccountState, flag: false });
    toastMessage.success(
      Messages["logout.success"].messageTitle,
      Messages["logout.success"].message
    );
    onLogoutClick?.();
    onClick();
  };
  // const handleEditPreference = () => {
  //   triggerGAEvent(GA_LABEL_ENUMS.home_preferences_click);
  //   if (isMobile) {
  //     navigateWithParams(ROUTES.PreviewPreference);
  //     onClick();
  //   } else {
  //     setLoginCreateAccountState({
  //       flag: true,
  //       page: DialogSelected.EDIT_PREFER,
  //     });
  //   }
  // };

  // const handleEditPreference = () => {
  //   triggerGAEvent(GA_LABEL_ENUMS.home_preferences_click);
  //   setIsFetchingMobileAirports(true);
  //   setLoginCreateAccountState({
  //     flag: true,
  //     page: DialogSelected.PREFERENCE,
  //   });
  //   setViewPreference(true);
  // };

  return (
    <div className={styles.main}>
      <div className={`${userInfo?.loggedIn ? styles.container : styles.inActiveContainer}`}>
        {/* <div className={styles.closeCard} onClick={() => {}}>
          <div>
            {" "}
            <Login closeDrawer={() => onClick()} />
          </div>
          <Button
            className={styles.closeButton}
            endIcon={<img src={newCloseIcon} alt="Close" className={styles.closeIcon} />}
            onClick={() => {
              onClick();
              triggerGAEvent(GA_LABEL_ENUMS.home_side_bar_close_click);
            }}
          >
            Close
          </Button>
        </div> */}
        {userInfo?.loggedIn && (
          <Box className={styles.profileCard}>
            <div className={styles.profileBox}>
              <Avatar
                alt=""
                src={userInfo?.profile_pic ? userInfo?.profile_pic : ""}
                sx={{
                  width: 40,
                  height: 40,
                }}
                className={styles.avatar}
              />
              {userInfo?.id && (
                <div className={styles.profileInfo}>
                  {/* {userDetails.name ? (
                    <p className={styles.userName}>
                      {userDetails?.name?.length < 15
                        ? userDetails.name
                        : userDetails.name.slice(0, 14) + "..."}
                    </p>
                  ) : ( */}
                  {userInfo?.name && (
                    <Typography size="size14" weight={600} color="neutralDarker" className={styles.userName}>
                      {userInfo?.name?.length < 15 ? userInfo?.name : userInfo?.name?.slice(0, 14) + "..."}
                    </Typography>
                  )}
                  {/* )
                  }
                  {userDetails.email ? (
                    <p className={styles.email}>
                      {userDetails.email.length < 20
                        ? userDetails.email
                        : userDetails.email.slice(0, 19) + "..."}
                    </p>
                  ) : ( */}
                  <Typography weight={600} size="size12" className={styles.email}>
                    {userInfo?.email?.length < 20 ? userInfo?.email : userInfo?.email?.slice(0, 19) + "..."}
                  </Typography>
                  {/* )}

                  {userDetails.phone ? (
                    <p className={styles.number}>
                      {formatPhoneNumber(userDetails.phone)}
                    </p>
                  ) : ( */}
                  <Typography className={styles.number}>{formatPhoneNumber(userInfo?.phone)}</Typography>
                  {/* )} */}
                  {/* <p className={styles.address}>Washington, DC</p> */}
                </div>
              )}
            </div>
            <div className={styles.editCard}>
              {" "}
              {/* <EditButton onClick={handleEditAccount} /> */}
              <AppButton
                iconBtn={newEditIcon}
                btnText=""
                onClick={handleEditAccount}
                iconHeight={20}
                variant="transparent"
                className={styles.bookIcon}
              />
            </div>
          </Box>
        )}
        {userInfo?.loggedIn && (
          <>
            <div className={styles.divider} />
            <button type="button" className={styles.logoutBtn} onClick={handleLogout} aria-label="Log out">
              <img src={logoutIcon} alt="" className={styles.logoutBtnIcon} />
              <Typography size="size16" weight={400} color="neutralDarkest" className={styles.logoutBtnLabel}>
                Log out
              </Typography>
              <img src={chevron_right} alt="" className={styles.logoutBtnChevron} />
            </button>
          </>
        )}
        {isMobile ? (
          <div className={styles.persBtnCard}>
            {/* <Button
              onClick={handleEditPreference}
              variant="text"
              endIcon={
                <img
                  src={personaliseIcon}
                  alt=""
                  className={styles.arrowIcon}
                />
              }>
              <span className={styles.personaliseBtn}>preferences</span>
            </Button> */}
          </div>
        ) : (
          <div className={styles.DeskBtnCard}>
            {/* <Button
              onClick={handleEditPreference}
              variant="text"
              startIcon={<img src={personaliseIcon} alt="" className={styles.arrowDeskIcon} />}
            >
              <span className={styles.deskBtn}>preferences</span>
            </Button> */}
          </div>
        )}
      </div>
    </div>
  );
}

export default Profile;
